import { useEffect, useRef, useState } from 'react'

/** Hydrate once per account and gate writes until its state has committed. */
export function useScreenerPreferenceHydration(storageKey: string, hydrate: () => void): boolean {
  const hydratedStorage = useRef<string | null>(null)
  const [hydratedStorageKey, setHydratedStorageKey] = useState<string | null>(null)

  useEffect(() => {
    // Availability refreshes may replace the callback, but must not restore old
    // browser choices over account defaults or temporary edits.
    if (hydratedStorage.current === storageKey) return
    hydratedStorage.current = storageKey
    try {
      hydrate()
    } finally {
      setHydratedStorageKey(storageKey)
    }
  }, [storageKey, hydrate])

  return hydratedStorageKey === storageKey
}
